import styles from "./NumberInputField.module.scss";
import { twMerge } from "tailwind-merge";
import ArrowUp from "components/General/Icons/ArrowUp";
import ArrowDown from "components/General/Icons/ArrowDown";

const NumberInputField = ({ value, onChange, ClassNames }) => {
  return (
    <div
      className={twMerge(
        "flex flex-row items-center h-12 bg-white border border-white select-none rounded-5 text-dark-text focus-within:border-primary w-fit",
        ClassNames?.container
      )}
    >
      <input
        className={twMerge(
          "h-12 bg-transparent text-lg w-14 p-0 border-transparent focus:border-transparent focus:ring-0 font-bold text-center",
          styles.input,
          ClassNames?.container
        )}
        type="number"
        min="1"
        value={value}
        onChange={(e) => {
          const new_value = e?.target?.value;
          onChange(new_value);
        }}
        onBlur={(e) => {
          const new_value = e?.target?.value;
          onChange(new_value);
        }}
      />
      <div className="flex flex-col pr-3 z-5">
        <ArrowUp
          className={twMerge("cursor-pointer", ClassNames?.arrow)}
          onClick={() => {
            const new_value = value + 1;
            onChange(new_value);
          }}
        />
        <ArrowDown
          className={twMerge(
            "cursor-pointer ",
            value == 1 && "cursor-default opacity-60",
            ClassNames?.arrow
          )}
          onClick={() => {
            if (value == 1) {
              return;
            }
            const new_value = value - 1;

            onChange(new_value);
          }}
        />
      </div>
    </div>
  );
};

export default NumberInputField;
